<template>
    <div id="sub-account-items-tab" class="sub-account-tab">
        <div class="tab-title">     
            <div class="tab-title-mian">
                <div @click="openSubAccountPopup('addItem','')" style="width: fit-content;">
                    <div class="icon-util sub-add-folder tab-title-icon"></div>
                    <span>{{$t('language.popup.subAccountPopup.addItemButton')}}</span>
                </div>
            </div> 
            <div class="tab-title-sub">
                <div class="sub-button" :style="buttonWidth()">
                    <div class="icon-util sub-add-user tab-title-icon" @click="openSubAccountPopup('addUser',clickItem)"></div>
                    <span @click="openSubAccountPopup('addUser',clickItem)">{{$t('language.popup.subAccountPopup.addUser.title')}}</span>
                </div>
                <div class="sub-button" :style="buttonWidth()">
                    <div class="icon-util sub-quick_assign tab-title-icon" @click="openSubAccountPopup('batchAddUser',clickItem)"></div>
                    <span @click="openSubAccountPopup('batchAddUser',clickItem)">{{$t('language.popup.subAccountPopup.quickAdd')}}</span>
                </div>
            </div>
        </div>
        <div class="tab-body">     
            <div class="main-table">
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr class="tab-th">
                        <th style="padding: 0 20px;">{{$t('language.popup.subAccountPopup.folders')}}</th>
                    </tr>
                </table>
                <el-scrollbar style='height:calc(100% - 40px);'>
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr :key="index" v-for="(item,index) in itemData" class="tab-tr" @click="getSubAccountList(item)" :class="item==clickItem?'tab-tr-hover':''">
                        <td :title="item.folderName" style="padding: 0 20px;">
                            <span style="width: 160px;">{{item.folderName}}</span>
                            <div class="icon-util remove tab-hover-icon" @click="openDeletePopup('ignore',false,item)" :title="$t('language.common.delete')" v-if="item.delId"></div>
                        </td>
                    </tr>
                </table>
                </el-scrollbar>
            </div>
            <div class="sub-table">
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr class="tab-th" :class="($i18n.locale=='deutsch'||$i18n.locale=='japanese'||$i18n.locale=='italian')?'other-tr':''">
                        <th class="th-one">{{$t('language.popup.subAccountPopup.users')}}</th>
                        <th class="th-two">
                            <div @click.stop="editAllItemLimits('read')" class="table-check-small">
                                <div class="icon-util sub-check"  :class="allRead?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.read')}}
                            <div class="icon-util question tab-question">
                                <div class="tab-questionTxt" style="left:530px">{{$t('language.popup.subAccountPopup.questionTxtRead')}}</div>
                            </div>
                        </th>
                        <th class="th-two">
                            <div @click.stop="editAllItemLimits('write')" class="table-check-small">
                                <div class="icon-util sub-check" :class="allWrite?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.write')}}
                            <div class="icon-util question tab-question">
                                <div class="tab-questionTxt" style="left:618px">{{$t('language.popup.subAccountPopup.questionTxtWrite')}}</div>
                            </div>
                        </th>
                    </tr>
                </table>
                <el-scrollbar style='height:calc(100% - 40px);'>
                <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
                    <tr :key="index" v-for="(item,index) in userData" class="tab-tr" 
                    :class="[item.id==clickSubAccountId?'tab-tr-hover':'',($i18n.locale=='deutsch'||$i18n.locale=='japanese'||$i18n.locale=='italian')?'other-tr':'']" @click="clickSubAccountId = item.id">
                        <td class="tr-one" :title="item.email" style="padding: 0 20px;">
                            <span>{{item.email}}</span>
                            <div class="icon-util remove tab-hover-icon" @click="openDeletePopup('',true,item)" :title="$t('language.common.delete')"></div>
                            <!-- <div class="icon-util reedit tab-hover-icon" @click="openSubAccountPopup('editUser',item.email)" :title="$t('language.leftBanner.edit')"></div> -->
                        </td>
                        <td class="tr-two">
                            <div @click.stop="addTableCheck(item,0)" class="table-check-small">
                                <div class="icon-util sub-check" :class="item.limits.read?'check-small':'nocheck-small'" ></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.allow')}}
                        </td>
                        <td class="tr-two" >
                            <div @click.stop="addTableCheck(item,1)" class="table-check-small">
                                <div class="icon-util sub-check" :class="item.limits.write?'check-small':'nocheck-small'"></div>
                            </div>
                            {{$t('language.popup.subAccountPopup.allow')}}
                        </td>
                    </tr>
                </table>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import '@/assets/css/sub_account_tab.css';
import commonUtils from "@/js/workspace/common_util.js";

export default {
    props:['allPermissionData'],//所有权限
    data: function () {
        return {
            itemData: [],
            userData: [],
            clickSubAccountId: "",
            clickItem: "",
            allRead: false,//全选读权限
            allWrite: false,//全选写权限
        }
    },
    mounted(){
        this.clickSubAccountId = "";
        //this.clickItem = "";
    },
    watch:{
        allPermissionData(val){
            this.getItemList();
        }
    },
    methods: {
        addTableCheck(item,type){
            let read = item.limits.read;
            let write = item.limits.write;
            switch (type) {
                case 0:
                    read = !item.limits.read;
                    item.limits.read = read;
                    type = "read";
                    break;
                case 1:
                    write = !item.limits.write;
                    item.limits.write = write;
                    type = "write";
                    break;
                default:
                    break;
            }
            this.editPermissionLimits(item,read,write,type);
        },
        openSubAccountPopup(type,item){
            this.$emit("openSubAccountPopup",type,item);
        },
        //打开删除弹窗
        openDeletePopup(type,isUser,item){
            const data = {
                isUser: isUser,//是否是删除子账号
                type: type,//删除类型
                delItem: item,//删除主体
            }
            this.$emit("openSubAccountPopup","delete",data);
        },
        //获取左侧项目列表
        getItemList(){
            let leftData = [];
            let isUnRepeat = true;
            this.allPermissionData.forEach(v => {
                isUnRepeat = true;
                for (let i = 0; i < leftData.length; i++) {
                    //重复时，添加权限到itemList
                    if(v.cloudId == leftData[i].cloudId && v.folderName == leftData[i].folderName){
                        if(v.emailId){
                            //v.name = v.email;//排序用
                            leftData[i].subList.push(v)
                        }
                        //有非空子账号权限时，该项目不可删除
                        if(leftData[i].delId){
                            leftData[i].delId = "";
                        }
                        isUnRepeat = false;
                        break;
                    }
                }
                //未重复时，添加到leftData
                if(isUnRepeat){
                    const item = {
                        //name: v.folderName,//用于排序
                        folderName: v.folderName,
                        cloudId: v.cloudId,
                        cloudType: v.cloudType,
                        folderId: v.folderId,
                        subList: [],
                        delId: "",//是否允许删除，及删除时的id
                    }
                    if(v.emailId && v.cloudId){
                        //非空子账号权限加入权限栏
                        //v.name = v.email;//排序用
                        item.subList.push(v)
                    }else{
                        //空子账号权限标记可删除
                        item.delId = v.id;
                    }
                    //没有cloudId不添加
                    if(v.cloudId){
                        leftData.push(item);
                    }
                }
            });
            this.itemData = leftData;
            //根据name排序
            // leftData.forEach(function (item,index) {
            //     console.log(item.subList)
            //     item.subList = commonUtils.sortJsonArrName(item.subList,true);
            // })
            // this.itemData = commonUtils.sortJsonArrName(leftData,true);

            //如果当前已有已选中item，则刷新右侧栏，如果已选择item已经不存在列表，清除clickItem
            //没有选中或选中失效时，默认选中第一个
            if(this.clickItem){
                let isHas = false;
                for (let i = 0; i < this.itemData.length; i++) {
                    if(this.itemData[i].cloudId == this.clickItem.cloudId
                    &&this.itemData[i].folderId == this.clickItem.folderId){
                        isHas = true;
                        this.getSubAccountList(this.itemData[i]);
                        break;
                    }
                }
                if(!isHas){
                    this.clickItem = "";
                    if(this.itemData.length>0){
                        this.getSubAccountList(this.itemData[0])
                    }
                }
            }else{
                if(this.itemData.length>0){
                    this.getSubAccountList(this.itemData[0])
                }
            }
        },
        //获取右侧子账号权限列表
        getSubAccountList(sub){
            this.clickItem = sub;
            this.clickSubAccountId = "";
            this.userData = sub.subList;
            this.changAllLimit();
        },
        //修改权限读写
        editPermissionLimits(item,read,write,type){
            let data = {
                ud: commonstate.user.id,
                id: item.id,
                read: read,
                write: write,
                type: type
            }
            let that = this;
            //关闭任意读或写权限，全部读或全部写取消
            switch (type) {
                case "read":
                    this.changAllRead();
                    break;
                case "write":
                    this.changAllWrite();
                    break;
                default:
                    break;
            }
            this.Utils.doPermissionRequest("update_limits", data).then(res => {
                if(res.status=="200"){
                }else{
                    switch (type) {
                        case "read":
                            item.limits.read = !read;
                            //全选状态回退
                            if(item.limits.read){
                                that.changAllRead();
                            }else{
                                that.allRead = false;
                            }
                            break;
                        case "write":
                            item.limits.write = !write;
                            //全选状态回退
                            if(item.limits.write){
                                that.changAllWrite();
                            }else{
                                that.allWrite = false;
                            }
                            break;
                        default:
                            break;
                    }
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "sub-account-items-tab"
                    });
                }
            })
        },
        editAllItemLimits(type){
            if(this.userData.length<1){
                return;
            }
            //type标识read还是write
            let data = {
                ud: commonstate.user.id,
                cloudId: this.clickItem.cloudId,
                folderId: this.clickItem.folderId,
                type: type+"_item"
            }
            let that = this;
            if(type=="read"){
                this.allRead=!this.allRead;
                data.read = this.allRead;
                this.userData.forEach(function(item,index){
                    item.limits.read = that.allRead;
                })
            }else if(type=="write"){
                this.allWrite=!this.allWrite;
                data.write = this.allWrite;
                this.userData.forEach(function(item,index){
                    item.limits.write = that.allWrite;
                })
            }
            this.Utils.doPermissionRequest("update_all_limits", data).then(res => {
                if(res.status=="200"){
                }else{
                    switch (type) {
                        case "read":
                            that.allRead = !that.allRead;
                            that.userData.forEach(function(item,index){
                                item.limits.read = that.allRead;
                            })
                            break;
                        case "write":
                            that.allWrite = !that.allWrite;
                            that.userData.forEach(function(item,index){
                                item.limits.write = that.allWrite;
                            })
                            break;
                        default:
                            break;
                    }
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "sub-account-items-tab"
                    });
                }
            })
        },
        //判断全选按钮
        changAllRead(){
            let temp = true;
            this.userData.forEach(v => {
                //任意一个为false，即为false
                if(!v.limits.read){
                    temp = v.limits.read;
                    return;
                }
            })
            //全部为true
            this.allRead = temp;
        },
        changAllWrite(){
            let temp = true;
            this.userData.forEach(v => {
                //任意一个为false，即为false
                if(!v.limits.write){
                    temp = v.limits.write;
                    return;
                }
            })
            //全部为true
            this.allWrite = temp;
        },
        changAllLimit(){
            let read = true;
            let write = true;
            this.userData.forEach(v => {
                //任意一个为false，即为false
                if(!v.limits.read){
                    read = v.limits.read;
                }
                if(!v.limits.write){
                    write = v.limits.write;
                }
                if(!read&&!write){
                    return;
                }
            })
            //全部为true
            if(this.userData.length>0){
                this.allRead = read;
                this.allWrite = write;
            }else{
                this.allRead = false;
                this.allWrite = false;
            }
        },
        buttonWidth(){
            if((this.$i18n.locale=='deutsch'||this.$i18n.locale=='france'||this.$i18n.locale=='japanese'||this.$i18n.locale=='italian')){
                return "width:32%;"
            }
        },
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_sub_account/tab_items.vue